// ---------------------------------------------------------------------------
// Bases y Propiedades — navigation config for the Amenidades & Reservas apps.
// Patio de Maniobras keeps its own TruckYardLayout; this config only drives the
// two new apps (their sub-menus + routes via routes.tsx + BasesLayout).
// ---------------------------------------------------------------------------

export interface BasesNavItem {
  id: string; // route segment under the app
  labelKey: string; // i18n key under `bases:menu` (namespace del módulo)
  icon: string; // remixicon
}

export interface BasesApp {
  /** App id — must match the apps-sidebar tile id (selected-app highlight). */
  id: "bases" | "amenidades" | "reservas" | "rondines";
  /** Route base, e.g. "/amenidades". */
  base: string;
  titleKey: string; // i18n key under apps.<id>.name
  remixIcon: string;
  menu: BasesNavItem[];
}

export const BASES_APPS: BasesApp[] = [
  {
    id: "bases",
    base: "/bases",
    titleKey: "bases",
    remixIcon: "ri-map-pin-2-line",
    menu: [
      { id: "locaciones", labelKey: "locaciones", icon: "ri-map-pin-2-line" },
      { id: "personal", labelKey: "personal", icon: "ri-team-line" },
    ],
  },
  {
    id: "amenidades",
    base: "/amenidades",
    titleKey: "amenidades",
    remixIcon: "ri-community-line",
    menu: [
      { id: "catalogo", labelKey: "catalogo", icon: "ri-community-line" },
    ],
  },
  {
    id: "reservas",
    base: "/reservas",
    titleKey: "reservas",
    remixIcon: "ri-calendar-check-line",
    menu: [
      { id: "dashboard", labelKey: "dashboard", icon: "ri-dashboard-line" },
      { id: "calendario", labelKey: "calendario", icon: "ri-calendar-2-line" },
      { id: "reservaciones", labelKey: "reservaciones", icon: "ri-calendar-check-line" },
    ],
  },
  {
    // Sub app Rondines (CC-CONSOLE #1592): rutas, puntos, programación,
    // rondas/bitácora e incidencias.
    id: "rondines",
    base: "/rondines",
    titleKey: "rondines",
    remixIcon: "ri-shield-check-line",
    menu: [
      { id: "tablero", labelKey: "tablero", icon: "ri-dashboard-3-line" },
      { id: "rutas", labelKey: "rutas", icon: "ri-route-line" },
      { id: "puntos", labelKey: "puntos", icon: "ri-map-pin-line" },
      { id: "programacion", labelKey: "programacion", icon: "ri-calendar-schedule-line" },
      { id: "rondas", labelKey: "rondas", icon: "ri-file-list-3-line" },
      { id: "incidencias", labelKey: "incidencias", icon: "ri-alarm-warning-line" },
    ],
  },
];

export const basesAppByBase = (pathname: string): BasesApp =>
  BASES_APPS.find((a) => pathname.startsWith(a.base)) ?? BASES_APPS[0];
